import { useState, useEffect } from "react";
import axios from "axios";
import DOMPurify from 'dompurify';
import { Link } from "react-router-dom";


const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};


const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};
const local = "https://localhost:44351/api/home/pliticsKhabars?page=1&limit=5"
const online = "https://api.shabdtoday.com/api/home/getdesh?page=1&limit=4"
// const online = "https://api.shabdtoday.com/api/home/pliticsKhabars?page=1&limit=5"


export default function AroundTheWorld() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(online);
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // Define your base URL for news images

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };
  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      // facebook: `https://www.
      // .com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      // whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`
    };
  };


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        {/* <Circles
          height="30"
          width="30"
          color="#ff6015"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }


  if (error) {
    return <div>Error: {error}</div>;
  }

  const baseUrl = "https://api.shabdtoday.com/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";
  return (
    <div>
      <div
        className="ak-block ak-block-3  ak-block-column ak-block-module-thumb-round ak-block-inner-boxed ak-block-width-1 clearfix"
        id="block_65f7f61f36732_9"
      >
        <div
          className="main-wdgt container pt-2"
          id="widget-rs-4937"
          data-vars-widget-type="home"
          data-vars-widget-name="astrology"
          data-vars-orderid={10}
        >
          <div className="wdgt-hdng">
            <h1 className="head">
              <Link to="/National-News" title="देश">
                {/* पॉलिटिक्स */}
                देश
              </Link>
            </h1>

          </div>
        </div>

        <div className="mt-2 ak-block-inner aroundtheworld clearfix">
          <div className="ak-block-posts clearfix">


            {posts.slice(0, 1).map((newsItem) => (
              <article key={newsItem.mainKhabarId} className="ak-module ak-module-3 ak-column-module clearfix ak-exclusive-post post-224 post type-post status-publish format-standard has-post-thumbnail  category-business category-featured category-tech-science category-us-news tag-breaking tag-election tag-politics tag-technology tag-world-news ak-exclusive-article">
                {newsItem.newsImage?.endsWith(".mp4") && (
                  <div className="ak-module-inner clearfix">
                    <div className="ak-module-grid-wrap">
                      <div className="ak-module-featured">
                        <span className="ak-module-format-icon format-video">
                          <i className="ak-icon fa fa-play" />
                        </span>
                        <div className="ak-featured-cover">
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            className="ak-featured-link"
                            rel="bookmark"
                            title={stripHtmlTags(newsItem.newsTag)}
                          >
                            <div className="ak-featured-thumb ">
                              <video
                                controls
                                autoPlay
                                style={{ height: "200", width: "400px" }}
                              >
                                <source
                                  src={baseUrl + newsItem.newsImage}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="ak-module-details">
                        <h1
                          className="ak-module-title">
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            rel="bookmark"
                            title={stripHtmlTags(newsItem.newsTag)}>
                            {stripHtmlTags(newsItem.newsTag)}
                          </Link>
                        </h1>
                      </div>
                    </div>
                  </div>
                )}

                {!newsItem.newsImage?.endsWith(".mp4") && (
                  <div
                    className="ak-module-inner clearfix"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "flex-start",
                      marginBottom: "0px",
                      paddingBottom: "0px",
                    }}
                  >
                    <div
                      className="ak-module-featured"
                      style={{
                        flex: "0 0 auto",
                        width: "385px",
                        marginRight: "0px",
                      }}
                    >
                      <div className="ak-featured-cover">
                        <Link
                          to={`/News-Details/${newsItem.slug}`}
                          className="ak-featured-link"
                          rel="bookmark"
                          title={stripHtmlTags(newsItem.newsTag)}
                        >
                          <img
                            loading="eager"
                            decoding="async"
                            width={350}
                            height={250}
                            src={baseUrl + newsItem.newsImage}
                            alt={stripHtmlTags(newsItem.newsTag, 80)}
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: "cover",
                              borderRadius: "8px",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            }}
                          />
                        </Link>
                      </div>
                    </div>

                    <div
                      className="ak-module-details"
                      style={{ flex: "1", minWidth: "0", marginTop: "10px" }}
                    >
                      <h1
                        className="ak-module-title"
                        style={{
                          fontSize: "1.2rem",
                          lineHeight: "1.5",
                          margin: "0",
                          fontWeight: 600,
                          fontFamily: "'Noto Sans Devanagari', sans-serif",
                        }}
                      >
                        <Link
                          to={`/News-Details/${newsItem.slug}`}
                          rel="bookmark"
                          title={newsItem.newsTag}
                          style={{ textDecoration: "none", color: "#212121" }}
                        >
                          {stripHtmlTags(newsItem.newsTag)}
                        </Link>
                      </h1>
                    </div>
                  </div>
                )}

              </article>
            ))}

            {posts.slice(1, 5).map((newsItem) => {
              const shareLinks = generateShareLinks(newsItem.mainKhabarId, newsItem.newsTag);
              return (
                <article key={newsItem.mainKhabarId} className="bordergap mb-2 ak-module ak-module-1-small ak-column-module ak-module-meta-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news">
                  {newsItem.newsImage?.endsWith(".mp4") && (
                    <div className="ak-module-inner clearfix">
                      <div className="ak-module-featured">
                        <div className="ak-module-video-duration">
                          <div className="active">Watch</div>
                        </div>
                        <span className="ak-module-format-icon format-video">
                          <i className="ak-icon fa fa-play" />
                        </span>
                        <div className="ak-featured-cover">
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            className="ak-featured-link"
                            rel="bookmark"
                            title={stripHtmlTags(newsItem.newsTag)}
                          >
                            <div className="ak-featured-thumb ">
                              <video
                                controls
                                autoPlay
                                style={{ height: "86", width: "120px" }}
                              >
                                <source
                                  src={baseUrl + newsItem.newsImage}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                            <span style={{ color: "" }}>
                              {getTimeAgoInHindi(newsItem.date)}
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div className="ak-module-details">
                        <h1
                          className="ak-module-title"

                        >
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            rel="bookmark"
                            title={stripHtmlTags(newsItem.newsTag)}
                          ><span style={{ fontSize: "15px", lineHeight: "22px" }} dangerouslySetInnerHTML={renderHtmlContent(newsItem.newsTag)} />
                          </Link>
                        </h1>
                      </div>
                    </div>
                  )}
                  {!newsItem.newsImage?.endsWith(".mp4") && (
                    <div className="ak-module-inner clearfix" style={{ marginBottom: "0px", paddingBottom: "0px" }}>
                      <div className="ak-module-featured" style={{ marginBottom: "0px", paddingBottom: "0px" }}>
                        <div className="ak-featured-cover">
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            className="ak-featured-link"
                            rel="bookmark"
                            title={stripHtmlTags(newsItem.newsTag)}
                          >
                            <div className="ak-featured-thumb  size-715" style={{ marginTop: "10%", marginBottom: "5%" }}>
                              <img
                                decoding="async"
                                width={120}
                                height={86}
                                src={baseUrl + newsItem.newsImage}
                                className="attachment-newsy_120x86 size-newsy_120x86 lazyload wp-post-image"
                                alt={stripHtmlTags(newsItem.newsTag)}
                                data-src={baseUrl + newsItem.newsImage}
                                data-sizes="auto"
                                data-srcset={baseUrl + newsItem.newsImage}
                                data-expand={700}
                              />
                            </div>

                          </Link>
                        </div>
                      </div>
                      <div className="ak-module-details">
                        <h1 className="ak-module-title" >
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            rel="bookmark"
                            aria-label=" खबरें और भी"
                            title={stripHtmlTags(newsItem.newsTag)}
                          > <span style={{ fontSize: "15px", lineHeight: "22px" }} dangerouslySetInnerHTML={renderHtmlContent(newsItem.newsTag)} />
                          </Link>
                        </h1>
                        <span style={{ color: "grey", fontSize: "12px" }}>
                          {getTimeAgoInHindi(newsItem.date)}
                        </span>
                      </div>
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
